'use client';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils/tailwind';

import type { HTMLAttributes, ReactNode } from 'react';

const listVariants = cva(
  'py-(--vertical-spacing-4) justify-between items-center',
  {
    variants: {
      type: {
        ordered: 'list-decimal',
        unordered: 'list-disc',
        custom: 'list-none',
      },
      spacing: {
        compact: 'space-y-2 text-sm',
        default: 'space-y-4',
      },
      icon: {
        none: '',
        custom: 'list-none',
      },
    },
    defaultVariants: {
      type: 'unordered',
      spacing: 'default',
      icon: 'none',
    },
  },
);

type ListProps = HTMLAttributes<HTMLUListElement | HTMLOListElement> &
  VariantProps<typeof listVariants> & {
    children: ReactNode;
  };

const Root = ({ type, spacing, className, children, ...props }: ListProps) => {
  const Component = type === 'ordered' ? 'ol' : 'ul';
  return (
    <Component
      className={cn(listVariants({ type, spacing }), className)}
      {...props}
    >
      {children}
    </Component>
  );
};

export { Root };
